module.exports = __webpack_public_path__ + "img/chinesecompany97.a6c1e319.png";